export default __webpack_public_path__ + "static/media/Appusers_A.62d84215.svg";